import React, { useRef } from 'react';
import(`./styles/${window.__litium.themeName}.scss`);

const SliderThumbnails = ({
  images,
  sliderRef,
  activeSlide,
  className = 'slider-thumbnails',
}) => {
  const goToSlide = (no) => {
    sliderRef.current.slickGoTo(no);
  };

  return (
    <div className={`${className}`}>
      {images.length > 0 &&
        images.map((img, i) => (
          <a
            key={'product-thumb-' + i}
            className={`${className}__thumb ${
              activeSlide === i ? `${className}__thumb--active` : ''
            }`}
            onClick={() => goToSlide(i)}
          >
            <img
              className={`${className}__thumb__image`}
              src={img.thumbnailUrl}
              alt={img.alt}
            />
          </a>
        ))}
    </div>
  );
};

export default SliderThumbnails;
